import type { Theme } from "@mui/material";

export const buildNotificationThemeStyles = (theme: Theme): string => {
  const contrastText = theme.palette.semantic.primary.contrastText;
  const snackbarShadow = theme.shadows[6] ?? theme.shadows[3];

  return `
    :root {
      --toastify-color-success: ${theme.palette.semantic.success.main};
      --toastify-color-error: ${theme.palette.semantic.error.main};
      --toastify-color-warning: ${theme.palette.semantic.warning.main};
      --toastify-color-info: ${theme.palette.semantic.info.main};
      --toastify-color-progress-light: ${contrastText};
      --toastify-color-progress-dark: ${contrastText};
      --toastify-color-progress-info: ${contrastText};
      --toastify-color-progress-success: ${contrastText};
      --toastify-color-progress-warning: ${contrastText};
      --toastify-color-progress-error: ${contrastText};
      --theme-notification-shadow: ${snackbarShadow};
      --theme-notification-close-tap-highlight: ${theme.palette.action.selected};
      --theme-notification-close-hover-bg: ${theme.palette.divider};
      --theme-notification-close-focus-outline: ${theme.palette.text.secondary};
      --theme-notification-close-active-bg: ${theme.palette.action.disabled};
    }
  `;
};
